import nxModule from 'nxModule';
import templateUrl from './help.template.html';
import './help.style.less';


nxModule.component('help', {
  templateUrl,
});